import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=228b401c&scoped=true&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=228b401c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b401c",
  null
  
)

export default component.exports